import { createClient } from 'contentful'

export const client = createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
    environment: 'master'
})


//tr
export async function getTeamMembers() {
    const entries = await client.getEntries({
        content_type: 'team',
        order: 'sys.createdAt'
    })

    return entries.items.map(item => {
        const imageUrl = item.fields.image?.fields?.file?.url
            ? `https:${item.fields.image.fields.file.url}`
            : null

        return {
            ...item.fields,
            image: imageUrl,
            id: item.sys.id
        }
    })
}

export async function getFAQs() {
    const entries = await client.getEntries({
        content_type: 'faq',
        order: 'sys.createdAt'
    });

    return entries.items.map(item => ({
        question: item.fields.question,
        answer: item.fields.answer,
        id: item.sys.id
    }));
}


